
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketing-agencies",
      function () {
        return require("private-next-pages/marketing-agencies.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketing-agencies"])
      });
    }
  